import type { Location } from "react-router-dom";
import { Link } from "react-router-dom";
import { CustomTypography } from "sipli-fleet-core/components";

export interface CustomerBreadcrumbItem {
  label: string;
  path?: string;
  state?: Location["state"];
}

interface CustomerBreadcrumbProps {
  items: CustomerBreadcrumbItem[];
  ariaLabel: string;
  separator?: string;
}

const CustomerBreadcrumb = ({ items, ariaLabel, separator = ">" }: CustomerBreadcrumbProps) => (
  <nav
    aria-label={ariaLabel}
    className="flex flex-wrap items-center gap-2 mt-1 text-[12px] text-gray8"
  >
    {items.map((item, index) => (
      <CustomTypography.CustomText
        key={`${item.label}-${index}`}
        className="flex items-center min-w-0 gap-2"
      >
        {index > 0 && (
          <span aria-hidden="true" className="text-gray9 !font-normal">
            {separator}
          </span>
        )}
        {item.path ? (
          <Link
            to={item.path}
            state={item.state}
            className="max-w-[180px] truncate transition-colors hover:text-primary !font-normal"
          >
            {item.label}
          </Link>
        ) : (
          <span className="max-w-[180px] truncate text-gray9 !font-normal">{item.label}</span>
        )}
      </CustomTypography.CustomText>
    ))}
  </nav>
);

export default CustomerBreadcrumb;
